export default __webpack_public_path__ + "static/media/bus_c1.01261033.svg";